import { render, staticRenderFns } from "./exerciseinfolist.vue?vue&type=template&id=2884a4a8&scoped=true"
import script from "./exerciseinfolist.vue?vue&type=script&lang=js"
export * from "./exerciseinfolist.vue?vue&type=script&lang=js"
import style0 from "./exerciseinfolist.vue?vue&type=style&index=0&id=2884a4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2884a4a8",
  null
  
)

export default component.exports